import React, { useEffect } from "react";
import { EVENT_BUS_EVENTS, useEventBus } from "../../util/useEventBus";
import { useDispatch } from "../../store";
import { updateIconAfterTopicUnfollow } from "../../store/actions";
import ToolMenu from "./ToolMenu";
import Toolbar from "./Toolbar";
import { Wrapper } from "./_.styled";

// The ContentActionMenu is a menu on the topic page
// it allows users to perform actions such as print, cite, follow, etc.
const ContentActionMenu = ({ tools, actions, an, isMobile }) => {
  const dispatch = useDispatch();
  const eventBus = useEventBus();

  const handleToolClick = (evt, tool) => {
    actions[tool.action]();
  };

  useEffect(() => {
    const handler = ({ topicAn: unfollowedTopicAn }) => {
      if (unfollowedTopicAn === an) {
        updateIconAfterTopicUnfollow({ dispatch });
      }
    };
    eventBus.on(EVENT_BUS_EVENTS.TOPIC_UNSUBSCRIBED, handler);

    return () => eventBus.detach(EVENT_BUS_EVENTS.TOPIC_UNSUBSCRIBED, handler);
  }, [eventBus, dispatch, an]);

  // on desktop and tablet we show all the icon buttons
  // on mobile we show a "Tools" text button that opens a menu.
  const ActionMenu = isMobile ? ToolMenu : Toolbar;

  return (
    <Wrapper isMobile={isMobile}>
      <ActionMenu tools={tools} onToolClick={handleToolClick} />
    </Wrapper>
  );
};

ContentActionMenu.displayName = "ContentActionMenu";

export default ContentActionMenu;
